interface Props {
  count?: number;
}

function SingleSkeleton() {
  return (
    <div className="card">
      {/* Header row: title + distance badge */}
      <div className="flex justify-between items-start">
        <div className="min-w-0 flex-1">
          {/* Title */}
          <div className="skeleton h-5 w-3/4 mb-2" />
          {/* Address line */}
          <div className="skeleton h-4 w-full mb-1" />
          {/* Island badge */}
          <div className="skeleton h-4 w-1/3" />
        </div>
        {/* Distance badge */}
        <div className="skeleton h-6 w-16 rounded-full flex-shrink-0 ml-2" />
      </div>

      {/* Phone / walk-ins row */}
      <div className="flex items-center gap-3 mt-3">
        <div className="skeleton h-4 w-24" />
        <div className="skeleton h-4 w-28" />
      </div>

      {/* Action buttons */}
      <div className="mt-4 flex gap-2">
        <div className="skeleton h-9 flex-1 rounded-full" />
        <div className="skeleton h-9 w-16 rounded-full" />
      </div>
    </div>
  );
}

export default function SkeletonCard({ count = 1 }: Props) {
  return (
    <div role="status" aria-busy="true" aria-label="Loading" className="contents">
      {Array.from({ length: count }, (_, i) => (
        <SingleSkeleton key={i} />
      ))}
    </div>
  );
}
